import { featureContent } from '@/mocks/seo-content';

export default function FeatureSection() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        {/* Label */}
        <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold uppercase tracking-wider mb-4">
          {featureContent.sectionLabel}
        </span>

        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight max-w-2xl whitespace-pre-line">
          {featureContent.headline}
        </h2>

        <p className="mt-5 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
          {featureContent.description}
        </p>

        {/* 4-column benefits */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featureContent.benefits.map((benefit, i) => (
            <div key={i} className="group">
              <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center mb-4 group-hover:bg-secondary-200 transition-colors">
                <span className="w-5 h-5 flex items-center justify-center text-secondary-700">
                  <i className={`${i === 0 ? 'ri-layout-grid-line' : i === 1 ? 'ri-refresh-line' : i === 2 ? 'ri-scales-line' : 'ri-global-line'} text-lg`}></i>
                </span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats row */}
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          {[
            { value: '14+', label: 'Product Categories' },
            { value: '50K+', label: 'Curated Listings' },
            { value: 'Daily', label: 'Data Refreshes' },
            { value: 'Global', label: 'Access Available' },
          ].map((stat, i) => (
            <div key={i}>
              <div className="text-3xl md:text-5xl font-heading font-bold text-foreground-900">
                {stat.value}
              </div>
              <div className="mt-2 text-xs md:text-sm text-foreground-500 font-medium uppercase tracking-wide">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}